import { createAsyncThunk } from '@reduxjs/toolkit'
import { importApi } from '@/services/api'
import IMPORT_ACTION_TYPE from '@/store/types/import'

const initializeServices = createAsyncThunk(
  IMPORT_ACTION_TYPE.INITIALIZE_SERVICES,
  async (payload) => {
    return await importApi.initializeServices(payload)
  }
)

const enrolDirectors = createAsyncThunk(IMPORT_ACTION_TYPE.ENROL_DIRECTORS, async (payload) => {
  return await importApi.enrolDirectors(payload)
})

const enrolYear4Teachers = createAsyncThunk(
  IMPORT_ACTION_TYPE.ENROL_YEAR_4_TEACHERS,
  async (payload) => {
    return await importApi.enrolYear4Teachers(payload)
  }
)

const enrolFamiliesCross = createAsyncThunk(
  IMPORT_ACTION_TYPE.ENROL_FAMILIES_CROSS,
  async (payload) => {
    return await importApi.enrolFamiliesCross(payload)
  }
)

const enrolFamiliesObserv = createAsyncThunk(
  IMPORT_ACTION_TYPE.ENROL_FAMILIES_OBSERV,
  async (payload) => {
    return await importApi.enrolFamiliesObserv(payload)
  }
)

export {
  initializeServices,
  enrolDirectors,
  enrolYear4Teachers,
  enrolFamiliesCross,
  enrolFamiliesObserv
}
